import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Fetcher from "../Provider/Fetcher";
import C3DTilesSource from "./C3DTilesSource";
/**
 * @classdesc
 * An object defining the source connection to a 3DTiles asset of a [Cesium ion server](https://cesium.com/learn/ion/).
 *
 * @extends Source
 *
 * @property {boolean} isC3DTilesIonSource - Used to checkout whether this source is a C3DTilesIonSource. Default is
 * true. You should not change this, as it is used internally for optimisation.
 * @property {string} url - The URL of the tileset json.
 * @property {string} baseUrl - The base URL to access tiles.
 * @property {string} accessToken - The Cesium ion access token used to retrieve the resource.
 * @property {string} assetId - The id of the asset on Cesium ion.
 */

var C3DTilesIonSource = /*#__PURE__*/function (_C3DTilesSource) {
  _inherits(C3DTilesIonSource, _C3DTilesSource);

  var _super = _createSuper(C3DTilesIonSource);

  /**
   * Create a new Source for 3D Tiles data from Cesium ion.
   *
   * @constructor
   * @extends Source
   *
   * @param {Object} source An object that can contain all properties of a C3DTilesIonSource and {@link Source}.
   * Only `accessToken` and `assetId` are mandatory.
   */
  function C3DTilesIonSource(source) {
    var _this;

    _classCallCheck(this, C3DTilesIonSource);

    if (!source.accessToken) {
      throw new Error('New 3D Tiles Ion Source: access token is required');
    }

    if (!source.assetId) {
      throw new Error('New 3D Tiles Ion Source: asset id is required');
    } // Url to query cesium ion the first time to retrieve metadata of the asset with assetId


    source.url = "https://api.cesium.com/v1/assets/".concat(source.assetId, "/endpoint?access_token=").concat(source.accessToken);
    _this = _super.call(this, source);
    _this.isC3DTilesIonSource = true;
    _this.accessToken = source.accessToken;
    _this.assetId = source.assetId; // get asset metadata

    _this.whenReady = Fetcher.json(source.url, _this.networkOptions).then(function (json) {
      if (json.type !== '3DTILES') {
        throw new Error("".concat(json.type, " datasets from Cesium ion are not supported with C3DTilesIonSource. ") + 'Only 3D Tiles datasets are supported.');
      }

      _this.url = json.url; // Store url to the tileset.json

      _this.baseUrl = json.url.slice(0, json.url.lastIndexOf('/') + 1); // baseUrl for tiles queries

      _this.networkOptions.headers = {};
      _this.networkOptions.headers.Authorization = "Bearer ".concat(json.accessToken);
      _this.attribution = json.attributions;
      return Fetcher.json(_this.url, _this.networkOptions);
    });
    return _this;
  }

  return _createClass(C3DTilesIonSource);
}(C3DTilesSource);

export default C3DTilesIonSource;